/*
  Functions to update the backend map viewer context, using the MapViewerServletNG endpoint.
  Was taken out of the more general maps-api so it can be used without pulling in the whole Open
  Layers dependency.
 */

import { ajax } from 'cadenza/api-client/api';
import type { DimensionDto } from 'cadenza/api-client/dto/dimension-dto';
import type { MapDto } from 'cadenza/api-client/dto/map-dto';

export function getMapContext (contextUrl: string, [ width, height ]: DimensionDto) {
  return ajax<MapDto>(contextUrl, { data: { width, height } });
}
